<script setup lang="ts">
import { SiteConfig } from '@/model'
import type { Api } from '@/api'
import { useSiteStore } from '@/stores/site'
import { inject, onMounted, ref } from 'vue'

const api = inject('exhibitorApi') as Api<unknown>
const sites = ref<SiteConfig[]>([])
const siteStore = useSiteStore()

const props = defineProps<{ size?: 'small' | 'large' }>()

onMounted(() => {
  api.common.allSitesList().then((res) => {
    sites.value = res.data.map((el) => new SiteConfig(el))
  })
})

function changeCurrentSite(site: SiteConfig) {
  let siteUrl = site.siteUrl
  if (import.meta.env.DEV) {
    siteUrl = 'http://localhost:8001/' + site.fairMasterCode
  }

  window.location.href = siteUrl
}
</script>

<template>
  <Select
    v-model="siteStore.siteConfig"
    placeholder="현재 사이트"
    :options="sites"
    :option-label="'siteName'"
    class="w-full"
    :size="props.size"
    :filter="true"
    scroll-height="20rem"
    @change="changeCurrentSite($event.value)" />
</template>
